export default __webpack_public_path__ + "static/media/darkgray-date-picker-icon.f32c1988.svg";